import { ColumnEyeTracking as ColumnEyeTrackingComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const ColumnEyeTracking = () => {
    const {
        combinedCustomChartsData,
        isFetchingCombinedCustomCharts,
        isErrorCombinedCustomCharts,
    } = useSessionDetailsContext();

    if (isFetchingCombinedCustomCharts) {
        return <ContentLoader height="21.1875rem" />;
    }

    const isEmptyState = !combinedCustomChartsData?.length;

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:eye-tracking:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="18.2rem"
                />
            </ComponentWrapper>
        );
    }

    if (isErrorCombinedCustomCharts && !isFetchingCombinedCustomCharts) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18.2rem"
                />
            </ComponentWrapper>
        );
    }

    return <ColumnEyeTrackingComponent data={combinedCustomChartsData} />;
};

export default ColumnEyeTracking;
